/**
 * Numbers as people read them, in the browser's own locale.
 *
 * `locale` is left out in the app, so the browser decides. Tests pass one, so
 * they do not depend on the machine they run on.
 */

/** A whole count with thousands separators: 12482 reads "12,482". */
export function formatCount(n: number, locale?: string): string {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(n);
}

/** A percentage to one decimal place, given as a percentage: 6.44 reads "6.4%". */
export function formatPercent(p: number, locale?: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(p / 100);
}
